import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCButton, RCCChartBubbleChart, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";

export interface IMatrizBcgChartRef{
    openModalChart: (mac004Id: number, title: string) => void;
}

const ModalChartMatrizBcg: React.ForwardRefRenderFunction<IMatrizBcgChartRef> = (_, ref) => {
	const { translate } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();

	const modalChart = useRef<RCCRefModalProps>(null);
	const [data, setData] = useState<any>();
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);

	const openModalChart = async (mac001IdX: number, titleAnalysis: string) => {
		try{
			setLoading(true);
			const response = await RCCServicesApi.getRequest({
				method: "AnalysisMatrizBcg/SelectDataChart",
				urlParameters: {
					mac001Id: mac001IdX
				}
			});

			setData(response.data);
			setLoading(false);
			setSubtitle(`${translate("Análise")}: ${titleAnalysis}`);

			modalChart.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar dados do gráfico"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalChart
	}));

	return (
		<>
			
			<Modal
				ref={modalChart}
				header={{
					title: translate("Gráfico Análise"),
					subtitle,
					icon: {
						name: "chartBar"
					}
				}}
				footer= {{
					showSaveButton: false,
					cancelButtonText: translate("Fechar")
				}}
			>
				<RCCButton
					styleInline="position: absolute; top: 100px; left: 100px"
					icon={{name: "question", color: "#fff", size: 14}}
					color="grey"
					layout="default"
					size="xs"
				>{translate("Dúvida")}</RCCButton>

				<RCCButton
					styleInline="position: absolute; top: 100px; right: 50px"
					icon={{name: "star", color: "#fff", size: 16}}
					color="grey"
					layout="default"
					size="xs"
				>{translate("Estrela")}</RCCButton>

				<RCCButton
					styleInline="position: absolute; bottom: 150px; left: 100px"
					icon={{name: "pineapple", color: "#fff", size: 16}}
					color="grey"
					layout="default"
					size="xs"
				>{translate("Abacaxi")}</RCCButton>

				<RCCButton
					styleInline="position: absolute; bottom: 150px; right: 50px"
					icon={{name: "cow", color: "#fff", size: 16}}
					color="grey"
					layout="default"
					size="xs"
				>{translate("Vaca Leiteira")}</RCCButton>

				<RCCChartBubbleChart
					width={500}
					height={400}
					data={data || []}
					yAxis={{
						label:{ value: translate("Crescimento de Mercado"), position: "insideLeft", offset: 0, angle: -90 },
						name: `${translate("Crescimento de Mercado")}`,
						range: [0, 3],
						domain: [0, (dataMax: number) => dataMax > 20 ? dataMax + 4 : 20]
					}}
					xAxis={{
						label:{ value: translate("Participação Relativa de Mercado"), position: "insideBottom", offset: 0},
						name: `Market-Share ${translate("Relativo")}`,
						range: [0, 20],
						domain: [0, (dataMax: number) => dataMax > 2 ? dataMax + 0.1 : 2]
					}}
					zAxis={{
						name: "Score",
						range: [1000, 10000]
					}}
					referenceLines={[
						{
							x: 1
						},
						{
							y: 10
						}
					]}
				/>
				
				
			</Modal>
			
		</>
	);
};

export default forwardRef(ModalChartMatrizBcg);
